import Redactor from 'redactor'
import { preserveBrSubscribe } from './preserve_br'
import 'redactor/plugins/alignment/alignment.min'
import 'redactor/plugins/blockbackground/blockbackground.min'
import 'redactor/plugins/blockborder/blockborder.min'
import 'redactor/plugins/blockclass/blockclass.min'
import 'redactor/plugins/blockcode/blockcode.min'
import 'redactor/plugins/blockcolor/blockcolor.min'
import 'redactor/plugins/blockfontsize/blockfontsize.min'
import 'redactor/plugins/blockid/blockid.min'
import 'redactor/plugins/blockspacing/blockspacing.min'
import 'redactor/plugins/clips/clips.min'
import 'redactor/plugins/counter/counter.min'
import 'redactor/plugins/definedlinks/definedlinks.min'
import 'redactor/plugins/email/email.min'
import 'redactor/plugins/emoji/emoji.min'
import 'redactor/plugins/filelink/filelink.min'
import 'redactor/plugins/fontcolor/fontcolor.min'
// import 'redactor/plugins/fontfamily/fontfamily.min'
import 'redactor/plugins/fontsize/fontsize.min'
import 'redactor/plugins/fullscreen/fullscreen.min'
import 'redactor/plugins/icons/icons.min'
import 'redactor/plugins/imageresize/imageresize.min'
// import 'redactor/plugins/math/math.min'
// import 'redactor/plugins/mention/mention.min'
// import 'redactor/plugins/mergetag/mergetag.min'
// import 'redactor/plugins/print/print.min'
import 'redactor/plugins/snippets/snippets.min'
import 'redactor/plugins/specialchars/specialchars.min'
import 'redactor/plugins/templates/templates.min'
// import 'redactor/plugins/textdirection/textdirection.min'
import 'redactor/plugins/textexpander/textexpander.min'
// import 'redactor/plugins/variable/variable.min'

const DEFAULT_PLUGINS = [
  'alignment',
  'blockbackground',
  'blockborder',
  'blockclass',
  'blockcode',
  'blockcolor',
  'blockfontsize',
  'blockid',
  'blockspacing',
  'clips',
  'counter',
  'definedlinks',
  // 'email',
  'emoji',
  'filelink',
  'fontcolor',
  // 'fontfamily',
  'fontsize',
  'fullscreen',
  'icons',
  'imageresize',
  // 'math',
  // 'mention',
  // 'mergetag',
  // 'print',
  'snippets',
  'specialchars',
  // 'templates',
  // 'textdirection',
  'textexpander',
  // 'variable',
]

const DEFAULT_SETTINGS = {
  plugins: DEFAULT_PLUGINS,
  context: true,
  subscribe: {
    ...preserveBrSubscribe,
  },
  layout: {
      grid: 'grid'
  },
  layouts: {
      set: true,
      'one-column': {
          title: 'One column',
          grid: 'grid',
          pattern: '-'
      },
      'two-columns': {
          title: 'Two columns',
          grid: 'grid md:grid-cols-2 gap-4',
          pattern: '-|-'
      },
      'three-columns': {
          title: 'Three columns',
          grid: 'grid md:grid-cols-3 gap-4',
          pattern: '-|-|-'
      },
      'four-columns': {
          title: 'Four columns',
          grid: 'grid md:grid-cols-4 gap-4',
          pattern: '-|-|-|-'
      }
  },
  embed: {
    responsive: true
  },
}

const buildRedactor = (selector, settings = {}) => {
  // 深度合併 subscribe，避免 caller 自己的 subscribe 蓋掉 DEFAULT_SETTINGS 的 subscribe
  // （直接用 ...settings 展開時，subscribe key 會被整個覆寫而非合併）
  const subscribe = { ...(DEFAULT_SETTINGS.subscribe || {}), ...(settings.subscribe || {}) }
  return Redactor(selector, { ...DEFAULT_SETTINGS, ...settings, subscribe })
}

export {
  DEFAULT_PLUGINS,
  DEFAULT_SETTINGS,
  buildRedactor,
}
